import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (mobile): one in-page hotel card
 * with a text CTA. The hotel card is a static placeholder; it is not a
 * template field.
 */
@Component({
  selector: 'app-pmax-display-mobile-04',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './display-mobile-04.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-mobile-04.component.scss'
})
export class PmaxDisplayMobile04PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton text lines above and below the ad, as % widths. */
  readonly linesAbove = [100, 100, 100, 100, 100, 100, 100, 75];
  readonly linesBelow = [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100];

  readonly hotel = { image: HOTELS + 'tamaris.jpg', title: 'Valamar Tamaris Hotel', subtitle: 'Najbolja cijena' };

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
